import { createContext, FC, ReactNode, useContext, useRef, useState } from "react";

type SessionContextType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sessionDuration: number;
  timeLeftRef: React.MutableRefObject<number>;
};

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const SessionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const sessionDuration = 1200;
  const timeLeftRef = useRef(sessionDuration); // no re-renders on children
  const [isOpen, setIsOpen] = useState(false);

  return (
    <SessionContext.Provider
      value={{
        isOpen,
        setIsOpen,
        sessionDuration,
        timeLeftRef,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSessionProvider = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSessionProvider must be used within an SessionProvider");
  }
  return context;
};
